import appInfoMap from '../isAppInstall/appInfoMap';
export function getToAppName(schema) {
    return Object.keys(appInfoMap).find((appName) => {
        const prefix = appInfoMap[appName]?.prefix || appName;
        return schema.startsWith(`${prefix}://`);
    });
}
export function getMarketUrl(app) {
    const appInfo = appInfoMap[app];
    if (!appInfo) {
        return {
            yingyongbao: '',
            androidMarket: '',
            iosMarket: '',
            pc: '',
        };
    }
    return {
        yingyongbao: `https://a.app.qq.com/o/simple.jsp?pkgname=${appInfo?.pkgName}`,
        androidMarket: `market://details?id=${appInfo?.pkgName}`,
        iosMarket: `https://apps.apple.com/cn/app/id${appInfo?.pkgId}`,
        pc: appInfo?.pc,
        getULink: appInfo?.getULink,
    };
}
